const S3_URI_PATTERN = /^s3:\/\/([^/]+)\/(.+)$/;
const DEFAULT_S3_REGION = "af-south-1";

export const resolveAssetUrl = (assetUrl?: string | null): string | undefined => {
  if (!assetUrl) return undefined;

  const match = assetUrl.match(S3_URI_PATTERN);
  if (!match) return assetUrl;

  const [, bucket, key] = match;
  return `https://${bucket}.s3.${DEFAULT_S3_REGION}.amazonaws.com/${encodeURI(key)}`;
};

export const resolveNullableAssetUrl = (assetUrl?: string | null): string | null => {
  return resolveAssetUrl(assetUrl) ?? null;
};
